import { Calendar } from "antd";
import type { CalendarProps } from "antd";
import type { Dayjs } from "dayjs";
import React from "react";

function AccountPayableCalender() {
  const onPanelChange = (
    value: Dayjs,
    mode: CalendarProps<Dayjs>["mode"],
  ) => {};
  return (
    <div className="min-h-screen flex flex-col">
      <div className="m-10">
        <Calendar onPanelChange={onPanelChange} />
      </div>
    </div>
  );
}

export default AccountPayableCalender;
